import { GOAL_MILESTONE, GOAL_STATUS, GOAL_TYPE } from '../constants/goals';
import { DATE_FORMAT_D_M_YYYY, DEFAULT_FILTER_VALUES, FILTERS } from '../constants/filters';
import I18n from 'I18n';
// @ts-expect-error Could not find declaration
import { isValid, toMomentUTC } from 'UIComponents/core/SimpleDate';
import { GOAL_CATEGORY_TABLE_CONFIG } from '../config/goalCategoryTableConfig';
import { GOAL_TYPE_CONFIG } from '../config/goalTypeConfig';

const getGoalTypeCrmQueryFilter = goalType => {
  if (Object.values(GOAL_TYPE).includes(goalType)) {
    return {
      property: 'hs_goal_type',
      operator: 'EQ',
      value: goalType
    };
  }

  return null;
};

const getMilestoneCrmQueryFilter = milestones => {
  const isValidMilestone = propMilestones => {
    for (const value of propMilestones) {
      if (!Object.values(GOAL_MILESTONE).includes(value)) {
        return false;
      }
    }

    return true;
  };

  return milestones && Array.isArray(milestones) && milestones.length && isValidMilestone(milestones) ? {
    property: 'hs_milestone',
    operator: 'IN',
    values: milestones
  } : null;
};

const getStatusCrmQueryFilter = status => {
  const isValidGoalStatus = propStatus => {
    for (const value of propStatus) {
      if (!Object.values(GOAL_STATUS).includes(value)) {
        return false;
      }
    }

    return true;
  };

  return status && Array.isArray(status) && status.length && isValidGoalStatus(status) ? {
    property: 'hs_status',
    operator: 'IN',
    values: status
  } : {
    property: 'hs_status',
    operator: 'IN',
    values: DEFAULT_FILTER_VALUES[FILTERS.STATUS]
  };
};

const getPercentProgressCrmQueryFilter = progress => {
  const isMinNumberType = progress && typeof progress.minPercentage === 'number';
  const isMaxNumberType = progress && typeof progress.maxPercentage === 'number';

  if (!progress) {
    return null;
  }

  const defaultProgress = DEFAULT_FILTER_VALUES[FILTERS.PERCENT_PROGRESS];
  const min = isMinNumberType ? progress.minPercentage : defaultProgress.minPercentage;
  const max = isMaxNumberType ? progress.maxPercentage : defaultProgress.maxPercentage;
  return {
    property: 'hs_kpi_progress_percent',
    operator: 'BETWEEN',
    value: min,
    highValue: max
  };
};

const getEndDateCrmQueryFilter = endDateFilter => {
  if (!endDateFilter || !isValid(endDateFilter.startDate) || !isValid(endDateFilter.endDate)) return null;
  const utcStart = I18n.moment.utc(toMomentUTC(endDateFilter.startDate), DATE_FORMAT_D_M_YYYY).valueOf();
  const utcEnd = I18n.moment.utc(toMomentUTC(endDateFilter.endDate), DATE_FORMAT_D_M_YYYY).endOf('day').valueOf();
  return {
    property: 'hs_end_datetime',
    operator: 'BETWEEN',
    dateTimeFormat: 'EPOCH_MILLISECONDS',
    value: utcStart,
    highValue: utcEnd
  };
};

const getAdAccountsCrmQueryFilter = adAccounts => {
  if (!adAccounts || !adAccounts.length) return null;
  return {
    property: 'hs_ad_account_asset_ids',
    operator: 'IN',
    values: adAccounts
  };
};

const getFilterValueFromFilterType = (filterType, propFilterValues) => {
  switch (filterType) {
    case FILTERS.END_DATE:
      return getEndDateCrmQueryFilter(propFilterValues.endDateRange);

    case FILTERS.GOAL_TYPE:
      return getGoalTypeCrmQueryFilter(propFilterValues.goalType);

    case FILTERS.MILESTONES:
      return getMilestoneCrmQueryFilter(propFilterValues.milestone);

    case FILTERS.PERCENT_PROGRESS:
      return getPercentProgressCrmQueryFilter(propFilterValues.percentProgressRange);

    case FILTERS.STATUS:
      return getStatusCrmQueryFilter(propFilterValues.status);

    case FILTERS.AD_ACCOUNTS:
      return getAdAccountsCrmQueryFilter(propFilterValues.adAccounts);

    default:
      return null;
  }
};

export const getDefaultCrmQueryFilters = () => {
  return [{
    property: 'hs_migration_soft_delete',
    operator: 'NEQ',
    value: true
  }];
};
export const getAllCrmQueryFilters = propFilterValues => {
  if (!propFilterValues.goalType) return [];
  const goalTypeConfig = GOAL_TYPE_CONFIG[propFilterValues.goalType];
  const goalCategory = goalTypeConfig && goalTypeConfig.category;
  if (!goalCategory) return [];
  const filtersForQuery = GOAL_CATEGORY_TABLE_CONFIG()[goalCategory].filters;
  return filtersForQuery.map(filterType => {
    const filterValue = getFilterValueFromFilterType(filterType, propFilterValues);
    if (!filterValue) return null;
    return filterValue;
  }).flat().filter(filter => filter);
};
export const getGoalTargetCrmQuery = (propFilterValues, offset, numGoalTargetsPerPage) => {
  const queryFilters = getAllCrmQueryFilters(propFilterValues);
  const defaultFilters = getDefaultCrmQueryFilters();
  return {
    count: numGoalTargetsPerPage,
    offset,
    filterGroups: [{
      filters: queryFilters.concat(defaultFilters)
    }]
  };
};
export const getAdCampaignCrmQuery = adCampaignIdsFromGoalTargets => {
  return {
    count: adCampaignIdsFromGoalTargets.length,
    filterGroups: [{
      filters: [{
        property: 'hs_ad_campaign_id',
        operator: 'IN',
        values: adCampaignIdsFromGoalTargets
      }]
    }]
  };
};